<template>
  <div id="projectRC">
    <div class="colspan">
      <div class="top clearfix">
        <p class="p1 clearfix">
          <i class="el-icon-s-order"></i>
          {{title}}
        </p>
        <p class="p2">
          <span>
            <em @click="getProjectListByValueTime('begin_time')">按时间</em>
            <i @click="getProjectListByValueTime('begin_time','asc')" class="el-icon-arrow-up"></i>
            <i @click="getProjectListByValueTime('begin_time','desc')" class="el-icon-arrow-down"></i>
          </span>
          <span>
            <em @click="getProjectListByValueMoney('donation_sum')">按筹款金额</em>
            <i @click="getProjectListByValueMoney('donation_sum','asc')" class="el-icon-arrow-up"></i>
            <i
              @click="getProjectListByValueMoney('donation_sum','desc')"
              class="el-icon-arrow-down"
            ></i>
          </span>
        </p>
      </div>
      <div class="content">
        <ul>
          <li class="list" v-for="(item,index) in projectList" :key="index" @click="goto(item.id)">
            <a>
              <img v-lazy="item.cover_photo_text.url" alt />
              <p :title="item.name">
                <span
                  :class="item.if_donation == 2 ? 'over' : '' "
                >{{item.if_donation==1?'筹款中':'筹款结束'}}</span>
                {{item.name}}
              </p>
            </a>
            <div>
              <p>
                <span>已筹到</span>
                <span
                  class="money"
                >￥{{Number(item.donation_sum)>10000 ? (Number(item.donation_sum)/10000).toFixed(2)+'万':item.donation_sum }}</span>
              </p>
              <p>
                <span>爱心人/次</span>
                <span class="number">{{item.donation_count}}</span>
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div class="page">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          layout="prev, pager, next"
          :page-size="page_size"
          :total="total"
          :hide-on-single-page="true"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import merge from "webpack-merge"
export default {
  data() {
    return {
      projectList: [],
      timeSort: "",
      moneySort: "",
      describe: "",
      title: "",
      page: 1,
      page_size:9,
      total: 0,
      cate_id: null,
      id: null, //导航id
      second_navId: null //二级导航
    };
  },
  methods: {
    goto(id) {
      let page = this.page?this.page:1;
      if (this.second_navId) {
        this.$router.push({
          name: "projectDetail",
          query: {
            id: this.id,
            second_navId: this.second_navId,
            projectInfoId: id,
            page
          }
        });
      } else {
        this.$router.push({
          name: "projectDetail",
          query: { id: this.id, projectInfoId: id,page}
        });
      }
    },
    prev() {},

    //点击下一页和点击页码时执行
    handleCurrentChange(val) {
      this.pageSync(val);
      this.getPageData();
    },
    //获取分页数据totalDataNumber
    // getPageData: function () {
    //     let that = this;
    //     // that.$db.post(this.$url.document.list,params).then(res=>{
    //     //     that.infoList = res.data.data
    //     //     that.total    = res.data.total
    //     // })
    // }.
    getProjectListByValueTime(order_by, order) {
      if (!order) {
        order = this.timeSort == "asc" ? "desc" : "asc";
        this.timeSort = order;
      } else {
        this.timeSort = order;
      }

      this.getProjectListByValue(order_by, order);
    },
    getProjectListByValueMoney(order_by, order) {
      if (!order) {
        order = this.moneySort == "asc" ? "desc" : "asc";
        this.moneySort = order;
      } else {
        this.moneySort = order;
      }

      this.getProjectListByValue(order_by, order);
    },
    getProjectListByValue(order_by, order) {
      this.page = 1;
      let that = this;
      this.$db
        .get(
          this.$url.project.list +
            "?page=" +
            this.page +
            "&page_size=" +
            this.page_size +
            this.cate_id +
            "&order_by=" +
            order_by +
            "&order=" +
            order
        )
        .then(res => {
          that.projectList = res.data.data;

          that.total = res.data.total;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getPageData() {
      let that = this;
      this.$db
        .get(
          this.$url.project.list +
            "?page=" +
            this.page +
            "&page_size=" +
            this.page_size +
            this.cate_id
        )
        .then(res => {
          that.projectList = res.data.data;
          that.total = res.data.total;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getCateValue(channelId) {
      let that = this;
      that.$db
        .get(this.$url.channel.url + "/" + channelId)
        .then(res => {
          that.title = res.data.title;

          return res.data.value.split(",");
        })
        .then(result => {
          if (result) {
            let value = "";
            result.forEach((item, index) => {
              let str = "&cate_id[" + index + "]=" + item;
              value += str;
            });
            this.cate_id = value;
            that.getPageData();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    pageSync(val){
      let query =this.$route.query;
       this.$router.push({
          query:merge(this.$route.query,{'page':val})
      });
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.second_navId = this.$route.query.second_navId;
    let that = this;
    if(this.$route.query.page){
      this.page = Number(this.$route.query.page);
      this.pageSync(this.page);
    }
    else{
      this.page=1;
      this.pageSync(1);
    }
    //接口导航ID 1,根据导航ID 查找这个导航绑定大分类
    let id = this.second_navId ? this.second_navId : this.id;
    that.$db
      .get(this.$url.channel.url + "/" + id)
      .then(res => {
        that.title = res.data.title;
        return res.data.value.split(",");
      })
      .then(result => {
        if (result) {
          let value = "";
          result.forEach((item, index) => {
            let str = "&cate_id[" + index + "]=" + item;
            value += str;
          });
          this.cate_id = value;
          that.getPageData();
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  watch: {
    "$route.query.id": function(value) {
      if (value) {
        this.id = value;
        this.page = 1;
        this.getCateValue(value);
      }
    },
    "$route.query.second_navId": function(value) {
      if (value) {
        this.second_navId = value;
        this.page = 1;
        this.getCateValue(value);
      } else if (typeof value == "undefined") {
        this.getCateValue(this.id);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.colspan {
  // float: left;
  width: 950px;
  // min-height: 500px;
  overflow: hidden;
  background-color: #ffffff;
  border: solid 1px #e5e5e5;
  box-sizing: border-box;
  // position: relative;
  > .top {
    > i {
      width: 104px;
      height: 2px;
      position: absolute;
      left: 30px;
      top: 0;
    }
    > .p1 {
      margin: 0;
      // float: left;
      display: inline-block;
      margin-left: 12px;
      font-size: 20px;
      height: 26px;
      border-top:2px solid #fff;
      padding-top: 20px;
    }
    > .p2 {
      position: relative;
      float: right;
      top: 0;
      right: 30px;
      font-size: 18px;
      color: #404040;
      margin-right: 30px;
      > span {
        display: inline-block;
        width: 120px;
        > em {
          font-style: normal
        }
        > i {
          position: absolute;
          cursor: pointer;
          margin-top: 10px;
          margin-left: 10px;
        }
        > i:nth-of-type(1){
          top: -10px;
        }
      }
    }
  }
  > .content {
    min-height: 500px;
    padding: 0 30px;
    > ul {
      list-style-type: none;
      padding: 0;
      margin-top: 16px;
      width: 100%;
      overflow: hidden;
      .list {
        display: inline-block;
        width: calc(33% - 20px);
        // height: 325px;
        // float: left;
        margin-right: 30px;
        overflow: hidden;
        box-sizing: border-box;
        border: 1px solid #ccc;
        margin-bottom: 30px;
        a {
            text-decoration:none;
            margin: 0;
            padding: 0;
            > img {
              width: 100%;
              // height: 202px;
            }
            > p{
            width: 100%;
            height: 50px;
            background-color: #fff;
            margin: 0;
            padding: 0 10px;
            font-size: 18px;
            line-height: 50px;
            margin-top: -10px;
            border-bottom: 1px dashed #ccc;
            font-size: 18px;
            color: #404040;
            box-sizing:border-box;
            overflow: hidden;    
            text-overflow: ellipsis;      //超出部分以省略号显示
            white-space: nowrap;
            > span {
              display: inline-block;
              height: 20px;
              background-color: #fff;
              border-radius: 4px;
              border: solid 1px #52a41e;
              text-align: center;
              line-height: 20px;
              font-size: 14px;
              color: #52a41e;
              padding: 2px;
            }
            > .over {
              background-color: #e5e5e5;
              color: #888;
              border: solid 1px #e5e5e5;
            } 
          }
        }
        > div {
          padding: 0 10px;
          height: 84px;
          > p {
            float: left;
            width: 50%;
            box-sizing: border-box;
            > span {
              display: inline-block;
              width: 100%;
              color: #888;
              font-size: 14px;
            }
            > .money {
              color: #ff3333;
              font-size: 20px;
            }
            > .number {
              color: #404040;
              font-size: 20px;
            }
          }
          > p:nth-of-type(1){
            border-right: 1px dashed #ccc;
          }
          > p:nth-of-type(2){
            padding-left: 16px;
          }
        } 
      }
      .list:nth-of-type(3n+0){
        margin-right: 0;
      }
    }
  }
  > .page {
    float: left;
    overflow: hidden;
    margin-left: 50%;
    margin-top: 20px;
    height: 100px;
    line-height: 100px;
    transform: translateX(-50%);
  }
  .page /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
      color: #fff ;
  }
  .page /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #ea373b ;
  }
  .page /deep/ .el-pagination.is-background .el-pager li:hover {
    color: #ea373b;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/project/rightContent.vue